module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deleteCloudAccountDialog.title":"Delete Cloud Connection","deleteCloudAccountDialog.subtitle":"Warning: This process is irreversible! Your cloud connection data will be deleted permanently and you will need to re-enter your credentials if you want to see your data again."}}')
  delete Component.options._Ctor
}
